var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9979 10.9998V10.9993H11.0007V6.96507C11.0007 4.99148 10.5758 3.47119 8.26856 3.47119C7.1594 3.47119 6.41506 4.07986 6.11119 4.6569H6.07911V3.65544H3.89148V10.9993H6.1694V7.3629C6.1694 6.40544 6.3509 5.47961 7.53661 5.47961C8.7049 5.47961 8.72231 6.57228 8.72231 7.42432V10.9998H10.9979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.182251 3.65625H2.46292V11.0001H0.182251V3.65625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.32165 0C0.592441 0 0.000732422 0.591708 0.000732422 1.32092C0.000732422 2.05013 0.592441 2.65421 1.32165 2.65421C2.05086 2.65421 2.64257 2.05013 2.64257 1.32092C2.64211 0.591708 2.0504 0 1.32165 0V0Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_806"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(0.000732422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.958d01693192fb7a2c330cd1f041dbc2.svg";
export { ForwardRef as ReactComponent };